export enum FieldType {
    AlphaNumericTextArea = 0,
    AlphaNumericInput = 1,
    Integer = 2,
    Decimal = 3,
    CheckboxYesOrNo = 4,
    Date = 5,
    Time = 6,
    Composite = 7,
    List = 8,
    MultipleChoicePicklist = 9,
}